import React from 'react'

interface TextIconProps{
  title?: string;
  icon?: JSX.Element;
  weight?: number;
  size?: number;
  leading?: number;
  gap?: number;
}

function TextIcon({...props}:TextIconProps) {
  return (
    <div className='polymer-text-icon' style={{gap: props.gap}}>
      <div className='polymer-text-icon__icon-container'>{props.icon}</div>
      <div className='polymer-text-icon__content-container' style={{fontWeight: props.weight, fontSize: props.size, lineHeight: props.leading+"px"}}>{props.title}</div>
    </div>
  )
}

export default TextIcon